export default __webpack_public_path__ + "static/media/chat-icon.69967bcd.svg";